<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >
    <b-col
      class="content-header-left mb-1"
      cols="12"
      md="9"
    >
      <b-row class="breadcrumbs-top">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper pl-1">
            <div class="d-flex align-items-center">
              <span
                v-if="$route.meta.breadcrumb.some(tab => tab.back === true)"
                class="mt-1 cursor-pointer back-button"
                @click="$router.go(-1)"
              >
                <img
                  src="../../../assets/images/skeleton/back.png"
                  alt=""
                  width="55px"
                  draggable="false"
                >
              </span>
              <b-breadcrumb>
                <b-breadcrumb-item
                  v-for="item in $route.meta.breadcrumb"
                  :key="item.text"
                  :active="item.active"
                  :to="item.to"
                  :class="$route.name == 'pages_profile' ? 'breadcrumb pl-1 pt-0 mt-1' : 'breadcrumb pl-1 pt-1'"
                >
                  {{ item.text }}
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
  },
}
</script>
